@if(loading){<lib-spinner-overlay></lib-spinner-overlay>}

<lib-dba-mat-table tableNameId="service" [data]="serviceList" [columnsdef]="columnsdefMain" [importButton]="false"
    [editButton]="permissionService.serviceSchreiben" [createButton]="permissionService.serviceSchreiben"
    [deleteButton]="permissionService.serviceLoeschen" [dynamicSize]="true" [(selectedElement)]="selectedService"
    (openDialog2)="OpenDialog($event)" (deleteClicked)="deleteData($event[0].ObjektID)">
</lib-dba-mat-table>